<template>
  <UlDialog v-model="dialog" width="800" title-left :title="$t('termsOfUse')">
    <template #text>
      <div v-html="$t(`${formLangKey}.agreements.termsConditions`)"></div>
    </template>
  </UlDialog>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'DynamicTermsConditionsModal',
  props: {
    identifier: {
      type: [String, Number],
      required: false
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  created() {
    this.$eventHub.$on(
      `openTermsConditionModal${this.identifier ? `_${this.identifier}` : ''}`,
      () => {
        this.dialog = true;
      }
    );
  },
  computed: {
    ...mapGetters({
      formLangKey: 'thematicCounselling/formLangKey'
    })
  },
  beforeDestroy() {
    this.$eventHub.$off(`openTermsConditionModal${this.identifier ? `_${this.identifier}` : ''}`);
  }
};
</script>
